import { PaintConfiguration } from "@/utils/productConfiguration/visuals/paintConfiguration/paintConfigurator.types";

export enum FeatureCodes {
    FinishFeatureCode = "Hubo_Classification_Catalog/GPC/10003874.4.027",
    VolumeFeatureCode = "Hubo_Classification_Catalog/GPC/10003874.hubo_att_inhoudliter",
    CoverageFeatureCode = "Hubo_Classification_Catalog/GPC/10003874.4.362"
}

export type PaintConfiguratorWizardState = Partial<
    PaintConfiguration["paintInfo"]
>;

export type PaintConfiguratorWizardStepMeta = {
    name: string;
};

export type FeatureInfo = {
    name: string;
    value: string;
};

export type VolumeInfo = {
    volume: FeatureInfo;
    coverage: FeatureInfo;
};
